/* istanbul ignore file */
//! PLEASE keep this list in alphabetical order for a better readability
export enum EMAIL_DOMAINS {
    /**
     * @value Add domain
     * @description Bouton to add an email domain
     */
    ADD_DOMAIN = 'EMAIL_DOMAINS.ADD_DOMAIN',
    /**
     * @value Add site
     */
    ADD_SITE = 'MOBILE.ADD_SITE',
    /**
     * @value Alias
     * @description Noun, label of a field to write another name used for an email domain, easier to read and remember. It can be the name of the platform, a website or anything alike. Examples "My website", "Lokalise", the name of the company...
     */
    ALIAS = 'EMAIL_DOMAINS.ALIAS',
    /**
     * @value Check configuration
     * @description Button to check that the domain configuration is validated
     */
    CHECK_CONFIGURATION = 'EMAIL_DOMIANS.CHECK_CONFIGURATION',
    /**
     * @value The domain "%DOMAIN_NAME%" cannot be modified after its creation
     * @description Description of a confirmation dialog to let user know what will happen if she confirms to create a new custom email domain (e.g my-domain.com)
     */
    CONFIRM_CREATION_DESCRIPTION = 'EMAIL_DOMAINS.CONFIRM_CREATION_DESCRIPTION',
    /**
     * @value Add domain?
     * @description Title of a dialog to ask the user if she REALLY wants to create a custom email domain (like my-domain.com)
     */
    CONFIRM_CREATION_TITLE = 'EMAIL_DOMAINS.CONFIRM_CREATION_TITLE',
    /**
     * @value Do you want to set %DOMAIN_NAME% as the platform's default domain?
     * @description Texte displayed in a dialog to ask the user if she's sure she wants to use the displayed email domain as the default one for the whole platform. %DOMAIN_NAME% looks like my-domain.com
     */
    CONFIRM_PLATFORM_DESCRIPTION_1 = 'EMAIL_DOMAINS.CONFIRM_PLATFORM_DESCRIPTION_1',
    /**
     * @value All sites that are not assigned to a custom domain will inherit that domain.
     * @description Description displayed in a confirm dialog when a user wants to assign a custom email domain to the whole platform (= with several sites)
     */
    CONFIRM_PLATFORM_DESCRIPTION_2 = 'EMAIL_DOMAINS.CONFIRM_PLATFORM_DESCRIPTION_2',
    /**
     * @value The domain %DOMAIN% will be removed. All sites currently using this domain will inherit the original domain: %DEFAULT%
     * @description Will be displayed as a warning in a confirm dialog when the user triers to remove a cutom email domain that is the platform's default one. %DOMAIN% will look like "my-domain.something.com" while %DEFAULT% will be "update.lumapps.com"
     */
    CONFIRM_REMOVE_DEFAULT = 'EMAIL_DOMAINS.CONFIRM_REMOVE_DEFAULT',
    /**
     * @value The domain %DOMAIN% will be removed. All sites currently using this domain will inherit the platform's default domain.
     * @description Will be displayed as a warning in a confirm dialog when the user triers to remove a cutom email domain. %DOMAIN% will look like "my-domain.something.com"
     */
    CONFIRM_REMOVE_NOT_DEFAULT = 'EMAIL_DOMAINS.CONFIRM_REMOVE_NOT_DEFAULT',
    /**
     * @value A custom domain lets you personalize the sender's email address for your site's notification emails. Once configured, you can use the domain with one or multiple sites or to with platform.
     */
    CREATION_DESCRIPTION = 'EMAIL_DOMAINS.CREATION_DESCRIPTION',
    /**
     * @value Email notifications received by users will take the form:
     */
    CREATION_HELPER = 'EMAIL_DOMAINS.CREATION_HELPER',
    /**
     * @value Email notifications from %SITE_NAME% received by users will take the form:
     * @description Text displayed in a dialog to let the user know that when she confirms, all emails sent from that specific site will be received from the following email address (something like notifications@my-domain.com)
     */
    CUSTOMIZE_SITE_HELPER = 'EMAIL_DOMAINS.CUSTOMIZE_SITE_HELPER',
    /**
     * @value DNS configuration
     * @description Step to configure a Domain Name System
     */
    DNS_CONFIGURATION = 'EMAIL_DOMAINS.DNS_CONFIGURATION',
    /**
     * @value Share these records with your IT department—they need to add them to your company’s DNS settings to enable email sending, receiving, and tracking. For more information, refer to the %DOC_LINK%.
     *
     * Add the following values to your DNS provider, then check the configuration.
     * @description Description of DNS configuration step, indicating the user what they should do with the displayed that and actions they need to proceed to validate the current step.
     */
    DNS_CONFIGURATION_DESCRIPTION = 'EMAIL_DOMAINS.DNS_CONFIGURATION_DESCRIPTION',
    /**
     * @value DNS not ready
     * @description Notification displayed when dns configuration is not ready yet
     */
    DNS_NOT_READY = 'EMAIL_DOMAINS.DNS_NOT_READY',
    /**
     * @value DNS validated
     * @description notification displayed when the dnc configuration is validated
     */
    DNS_VALIDATED = 'EMAIL_DOMAINS.DNS_VALIDATED',
    /**
     * @value Domains management
     */
    DOMAINS_MANAGEMENT = 'DOMAINS_MANAGEMENT.TITLE',
    /**
     * @value Domain created
     * @description Label of a notification to let the user know that her custom email domain has been created
     */
    DOMAIN_CREATED = 'EMAIL_DOMAINS.DOMAIN_CREATED',
    /**
     * @value Domain name
     * @description Label of a field asking the user what is the name of the custom email domain she wants to use (e.g my-domain.com)
     */
    DOMAIN_NAME = 'EMAIL_DOMAINS.DOMAIN_NAME',
    /**
     * @value Domain test
     * @description Step allowing users to test their configured domain namehas correclty been configured
     */
    DOMAIN_TEST = 'EMAIL_DOMAINS.DOMAIN_TEST',
    /**
     * @value Confirm that the test has been successful. If not, check the records and inbound emails with your IT department.
     * @description "records" and "inbound emails" are related to email domain configuratin. Below this message are displayed 2 buttons: "Retry test" and "Confirm"
     */
    DOMAIN_TEST_CONFIRM_MESSAGE = 'EMAIL_DOMAINS.DOMAIN_TEST_CONFIRM_MESSAGE',
    /**
     * @value Send a test email to ensure your domain is correctly configured. In the received email, the sender's address should appear as:
     * @description Right after ":" will be displayed a email address looking like "John Doe via MySite <notifications@my-domain.com>"
     */
    DOMAIN_TEST_MESSAGE = 'EMAIL_DOMAINS.DOMAIN_TEST_MESSAGE',
    /**
     * @value Email domains
     * @description Page to customize email domains
     */
    EMAIL_DOMAINS = 'EMAIL_DOMAINS.EMAIL_DOMAINS',
    /**
     * @value Email prefix
     * @description Label of a field used to write the part before @ in an email address (prefix@email.com). Examples: notifications, updates.my-website, noreply...
     */
    EMAIL_PREFIX = 'EMAIL_DOMAINS.EMAIL_PREFIX',
    /**
     * @value This page lists all custom domains available for your platform
     * @description Message explaning the purpose of the current page
     */
    EMPTY_STATE_MESSAGE = 'EMAIL_DOMAINS.EMPTY_STATE_MESSAGE',
    /**
     * @value No custom domains yet
     * @description Message to be displayed in an empty state to notify the user that there's no custom domain that has been added yet
     */
    EMPTY_STATE_TITLE = 'EMAIL_DOMAINS.EMPTY_STATE_TITLE',
    /**
     * @value Invalid name. The email domain cannot be the same as the vanity url.
     * @description Error message displayed to a user trying to create a custom email domain when the domain name is the same as the vanity url
     */
    ERROR_CONFLICT_WITH_VANITY_URL = 'EMAIL_DOMAINS.ERROR_CONFLICT_WITH_VANITY_URL',
    /**
     * @value This domain is already configured.
     * @description Error message displayed to a user trying to create a custom email domain which has already been configured and is already ready to use
     */
    ERROR_DOMAIN_ALREADY_CONFIGURED = 'EMAIL_DOMAINS.ERROR_DOMAIN_ALREADY_CONFIGURED',
    /**
     * @value This domain is unavailable, try another domain.
     * @description Error message displayed to a user trying to create a custom email domain which is not available in mailgun (email domains tool)
     */
    ERROR_DOMAIN_ALREADY_EXISTS = 'EMAIL_DOMAINS.ERROR_DOMAIN_ALREADY_EXISTS',
    /**
     * @value Invalid name
     * @description Text displayed to the user when a text field is not properly filled.
     */
    ERROR_DOMAIN_NAME_INVALID = 'MOBILE.CONFIGURATION_INVALID_NAME',
    /**
     * @value Inbound emails
     */
    INBOUND_EMAILS = 'EMAIL_DOMAINS.INBOUND_EMAILS',
    /**
     * @value Make sure your servers accept inbound emails from these IP addresses to prevent emails from being marked as spam for your users:
     */
    INBOUND_EMAILS_DESCRIPTION = 'EMAIL_DOMAINS.INBOUND_EMAILS_DESCRIPTION',
    /**
     * @value Your current platform domain is: %DOMAIN%
     * Add a new custom domain to set it as your platform's default domain.
     *
     * For more information, refer to the %DOC_LINK%
     * @description Information message displayed on email domains' page to explain the user what they should do
     */
    INFO_MESSAGE = 'EMAIL_DOMAINS.INFO_MESSAGE',
    /**
     * @value Allowed characters: %CHARACTERS%
     * @description This rule is used to confirm that a custom email domain name created by the user is valid
     */
    NAME_HELPER_RULE_1 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_1',
    /**
     * @value Cannot start with: %CHARACTERS%
     * @description This rule is used to confirm that a custom email domain created by the user is valid
     */
    NAME_HELPER_RULE_2 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_2',
    /**
     * @value No consecutive dots “..”
     * @description This rule is used to confirm that a custom email domain name created by the user is valid
     */
    NAME_HELPER_RULE_3 = 'EMAIL_DOMAINS.NAME_HELPER_RULE_3',
    /**
     * @value No sites using this domain yet
     * @description Label of an empty list of sites assigned to a custom email domain
     */
    NO_ASSIGNMENT = 'EMAIL_DOMAINS.NO_ASSIGNMENT',
    /**
     * @value Domain set as platform default
     * @description Label of a notification that confirms that the email domain has been set as the default one for the whole platform
     */
    PLATFORM_ASSIGNMENT_CONFIRMED = 'EMAIL_DOMAINS.PLATFORM_ASSIGNMENT_CONFIRMED',
    /**
     * @value Receiving records
     */
    RECEIVING_RECORDS = 'EMAIL_DOMAINS.RECEIVING_RECORDS',
    /**
     * @value Install the provided MX records to route incoming mail through Mailgun, unless your domain already uses another provider (like Gmail) for receiving email.
     */
    RECEIVING_RECORDS_DESCRIPTION = 'EMAIL_DOMAINS.RECEIVING_RECORDS_DESCRIPTION',
    /**
     * @value Record name
     */
    RECORD_NAME = 'DOMAINS_MANAGEMENT.RECORD_NAME',
    /**
     * @value Record value
     */
    RECORD_VALUE = 'DOMAINS_MANAGEMENT.RECORD_VALUE',
    /**
     * @value The site %SITE% will not be using the domain %DOMAIN_NAME% anymore. It will inherit the platform default domain.
     * @description Message to be displayed in confirm dialog when removing a site assigned to the current domain
     */
    REMOVE_SITE_MESSAGE = 'EMAIL_DOMAINS.REMOVE_SITE_MESSAGE',
    /**
     * @value Retry test
     * @description Label of a button inviting the user to do another test when the previous one has not been successful
     */
    RETRY_TEST = 'EMAIL_DOMAINS.RETRY_TEST',
    /**
     * @value Sending records
     */
    SENDING_RECORDS = 'EMAIL_DOMAINS.SENDING_RECORDS',
    /**
     * @value Send me a test
     * @description Label of a button that aims to send a test (of something, can be an email or whatever) to the current user (= me)
     */
    SEND_ME_A_TEST = 'EMAIL_DOMAINS.SEND_ME_A_TEST',
    /**
     * @value Set as platform default
     * @description Label of a button that triggers the action
     */
    SET_AS_PLATFORM_DEFAULT = 'EMAIL_DOMAINS.SET_AS_PLATFORM_DEFAULT',
    /**
     * @value Set as platform default?
     * @description Title of a dialog, asking the user if she's sure she wants to change the current email domain of the whole platform to a new one.
     */
    SET_AS_PLATFORM_DEFAULT_QUESTION = 'EMAIL_DOMAINS.SET_AS_PLATFORM_DEFAULT_QUESTION',
    /**
     * @value Site added
     * @description Used in an alert displayed when a site is added (to an email domain, for example). It's a short for "The site has been added"
     */
    SITE_ADDED = 'EMAIL_DOMAINS.SITE_ADDED',
    /**
     * @value Site removed
     * @description toaster confirming site removal
     */
    SITE_REMOVED = 'EMAIL_DOMAINS.SITE_REMOVED',
    /**
     * @value Tracking records
     */
    TRACKING_RECORDS = 'EMAIL_DOMAINS.TRACKING_RECORDS',
    /**
     * @value The CNAME record is necessary for tracking opens and clicks.
     */
    TRACKING_RECORDS_DESCRIPTION = 'EMAIL_DOMAINS.TRACKING_RECORDS_DESCRIPTION',
    /**
     * @value Use domain
     * @description Last step of a domain configuration. Users can now use their configured domain
     */
    USE_DOMAIN = 'EMAIL_DOMAINS.USE_DOMAIN',
    /**
     * @value This domain is your platform default domain. All sites that are not assigned to a custom domain inherit of this domain. All email notifications from these sites received by users will take the form:
     * @description This description is followed by an example of email domain that looks like that "John Doe via My Site <notifications@my-domain.com>"
     */
    USE_DOMAIN_PLATFORM_HELPER = 'EMAIL_DOMAINS.USE_DOMAIN_PLATFORM_HELPER',
}
